import React from "react";
import { Handle, Position } from "reactflow";

import ParamHeader from "./ParamHeader";

import "./ParameterIntentNode.scss";

const ParameterIntentNode = ({ id }) => {
  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="entry-node-container">
        <ParamHeader id={id} />
      </div>
    </>
  );
};

export default ParameterIntentNode;
